import Historic from './Historic'
import HistoricReport from './HistoricReport'
import Report from './Report'
import Stock from './Stock'

export {
  Historic,
  HistoricReport,
  Report,
  Stock
}



// WEBPACK FOOTER //
// ./src/containers/Inventory/index.js